<template>
  <vs-popup class="formula_note_update_popup"
            id="popup"
            title="FORMULATION UPDATE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input v-model="formulation.name" class="w-full"  name="name" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="legal_name" name="legal_name" rules="required" v-slot="{ errors }">
                <small class="label">Legal Name</small>
                <vs-input v-model="formulation.legal_name" class="w-full"  name="legal_name" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="batch_weight" name="batch_weight" rules="required" v-slot="{ errors }">
                <small class="label">Batch weight (Kg)</small>
                <vs-input type="number" v-model="formulation.batch_weight" class="w-full"  name="batch_weight" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <ValidationProvider vid="customer_project_brief_id" name="customer_project_brief_id" rules="" v-slot="{ errors }">
                <small class="label">Project brief</small>
                <v-select  :clearable="false" name="customer_project_brief_id" placeholder="" label="name" v-model="formulation.customer_project_brief_id" :reduce="option => option.id" :options="project_briefs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.name}}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="clean_time" name="clean_time" rules="required" v-slot="{ errors }">
                <small class="label">Clean Time Between Uses (H:m)</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" class="w-full" v-model="formulation.clean_time"
                            placeholder="H:m"/>
<!--                <vs-input v-model="formulation.clean_time"  name="clean_time" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="expiration_days" name="expiration_days" rules="required" v-slot="{ errors }">
                <small class="label">Expiration Days</small>
                <vs-input v-model="formulation.expiration_days"  name="expiration_days" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3 mt-12">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <small class="label">Formulation type</small>
                <v-select v-on:input="onChangeTypeInput"  name="formulation_type"  v-model="formulation.formulation_type" :options="['powder', 'liquid', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="min_order_quantity" name="min_order_quantity" rules="required" v-slot="{ errors }">
                <small class="label">Min order quantity (Kg)</small>
                <vs-input type="number" v-model="formulation.min_order_quantity" class="w-full"  name="min_order_quantity" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="number_of_hours" name="number_of_hours" rules="required" v-slot="{ errors }">
                <small class="label">Labour hours per batch</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" class="w-full" v-model="formulation.number_of_hours"
                            placeholder="H:m"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="machine_number_of_hours" name="machine_number_of_hours" rules="required" v-slot="{ errors }">
                <small class="label">Production line time allocation</small>
                <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}" class="w-full" v-model="formulation.machine_number_of_hours"
                            placeholder="H:m"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_cost" name="sundry_cost" rules="required" v-slot="{ errors }">
                <small class="label">Sundry cost (£)</small>
                <vs-input v-model="formulation.sundry_cost" class="w-full"  name="sundry_cost" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="commodity_code" name="commodity_code" rules="required" v-slot="{ errors }">
                <small class="label">Commodity code</small>
                <vs-input v-model="formulation.commodity_code" class="w-full"  name="commodity_code" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3 mt-12" v-if="formulation.notes.length > 0">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Previous Notes</small>
              <vs-textarea readonly class="mb-0" v-model="formulation.notes" height="150px" />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="dosage_info" name="dosage_info" rules="" v-slot="{ errors }">
                <small class="label">MAX Dosage</small>
                <vs-textarea class="mb-0" v-model="formulation.dosage_info" height="50px" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="comment" name="comment" rules="" v-slot="{ errors }">
                <small class="label">New Notes</small>
                <vs-textarea class="mb-0" v-model="newNote" height="150px" />
              </ValidationProvider>
            </div>
          </div>

          <div v-can="'edit-formulations'" class="flex flex-wrap items-center justify-end">
            <vs-button button="submit" class="ml-auto mt-2">Save changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations')
  const CustomerRepository = RepositoryFactory.get('customer')
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      id: '',
      form: {},
      formulation: {},
      project_briefs: [],
      newNote: ''
    }
  }

export default {
  name: 'BatchWeightUpdateFormulationPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        await this.loadFormulations()
        await this.fetchProjectBrief()
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async onClickUpdate () {
      const vue = this;
      try {
        this.$vs.loading();
        const payload = {
          name: this.formulation.name,
          legal_name: this.formulation.legal_name,
          batch_weight: this.formulation.batch_weight,
          notes: this.formulation.notes + ' \n' + this.newNote,
          customer_project_brief_id: this.formulation.customer_project_brief_id,
          formulation_type: this.formulation.formulation_type,
          min_order_quantity: this.formulation.min_order_quantity,
          gross_margin: (Number(this.formulation.gross_margin)).toFixed(2),
          labour_charge_per_hour: (Number(this.formulation.labour_charge_per_hour)).toFixed(2),
          number_of_hours: this.formulation.number_of_hours,
          machine_charge_per_hour: (Number(this.formulation.machine_charge_per_hour)).toFixed(2),
          machine_number_of_hours: this.formulation.machine_number_of_hours,
          sundry_cost: (Number(this.formulation.sundry_cost)).toFixed(2),
          clean_time: this.formulation.clean_time,
          expiration_days: this.formulation.expiration_days,
          dosage_info: this.formulation.dosage_info,
          commodity_code: this.formulation.commodity_code,
        }
        await FormulationsRepository.updateFormulationsNote(this.id, payload)
        this.showSuccessMessage('Formulation updated');
        await vue.$parent.refreshData()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close();
    },
    async loadFormulations() {
      this.$vs.loading()
      const {data} = await FormulationsRepository.details(this.id)
      this.formulation =  data.data
      this.$vs.loading.close()
    },
    async fetchProjectBrief() {
      this.$vs.loading()
      const {data} = await DropDownRepository.getProjectBriefDropDownList()
      this.project_briefs =  data.data
      this.$vs.loading.close()
    },
    onChangeTypeInput() {
      if (this.formulation.formulation_type === 'liquid') {
          this.formulation.min_order_quantity = '10'
      }
      if (this.formulation.formulation_type === 'powder') {
        this.formulation.min_order_quantity = '5'
      }
    }
  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .formula_note_update_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }
</style>
